import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IOneOrderPayload {
    orderId: string
    sagaCB?: {
        onSuccess: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const oneSubscriptionOrder = createSlice({
    name: 'subscriptions/one-subscription-order',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IOneOrderPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const oneOrderActions = oneSubscriptionOrder.actions
export default oneSubscriptionOrder.reducer
